import { Handle, Position } from "@xyflow/react";

const InvestingHandles: React.FC<{
  nodeId: string;
}> = ({ nodeId }) => (
  <>
    <Handle
      id={`${nodeId}-invested-in`}
      type="target"
      position={Position.Top}
    />
    <Handle
      id={`${nodeId}-investing-out`}
      type="source"
      position={Position.Bottom}
    />
  </>
);

export default InvestingHandles;
